module.exports = __webpack_public_path__ + "static/media/Adjunta_credencial_ambosLados.e03ee1ae.gif";